import { mapToArrayForSerialization } from "../../utils/price-consolidation";
import {
  SET_PRODUCT,
  UPDATE_INSEAMS_GRAPH,
} from "../actions/product-detail-page";

const defaultState = {
  productIdToInseamMap: [],
  inseamsGraph: [],
};

const productDetailPage = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SET_PRODUCT:
      return {
        ...state,
        ...payload,
      };
    case UPDATE_INSEAMS_GRAPH:
      return {
        ...state,
        inseamsGraph: mapToArrayForSerialization(payload.inseamsGraph),
        productIdToInseamMap: mapToArrayForSerialization(
          payload.productIdToInseamMap
        ),
      };
    default:
      return state;
  }
};

export default productDetailPage;
